  var cart_info = null;
  function sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
  }
  function formatAttribute(val) {
        if (val == null || typeof val == 'undefined') return '';
        return val.replaceAll('[-split1-]', ':').replaceAll('[-split2-]', '"');
  };
  async function getCart() {
        const result = await fetch('/cart.js');
        if (result.status === 429) {
          location.href = '/cart';
          return;
        }else if(result.status !== 200){   
            const contentType = response.headers.get('content-type') || '';        
            if (contentType.includes('application/json') || contentType.includes('text/javascript')) {
              const response_json = await response.json();
              if(response_json.description){
                alert(response_json.description);
              }else{
                alert('request cart error.');              
              }           
            }else{
              alert(await response.text());         
            }
            return;
        }else  if (result.status === 200) {
          return result.json();
        }
        console.log(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  };

  async function addItem(data = {}) {
        const result = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(data),
        });
        return result;
  };

   async function addSampleDoor(_obj) {
    var $this = $(_obj);
    Show_Loading('Add sample to cart...');
    var cartItem = {
      id: $this.attr('data-value'),
      quantity: 1,
    };
    cartItem.properties = {};
    cartItem.properties._ideal_doorstyle = $this.attr('data-door-style');
    cartItem.properties._ideal_product_program = $this.attr('data-program');
    cartItem.properties._ideal_production_value = $this.attr('data-productionvalue');
    cartItem.properties._ideal_is_sample_door = 'true';


    var is_island_value = 'false';
    if( $this.attr('data-is-island') =='true' ){
      is_island_value = 'true';
    }
    cartItem.properties._ideal_is_island = is_island_value;

    if (!await validAddToCart(is_island_value)) {
      if (is_island_value == 'false') {
        showIdealCartModal('Your cart already contains Island products. Please clear your cart before adding non-Island products.');
      } else {
        showIdealCartModal('Your cart already contains non-Island products. Please clear your cart before adding Island products.');
      }

      Hide_Loading();
      return;
    }



    var addCarts = await addItem(cartItem)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(async (response) => {
        cart_info = await getCart();
        if (cart_info != null && cart_info.item_count > 0) {
          $('#minicartitemquantity').html(cart_info.item_count);
        } else {
          $('#minicartitemquantity').empty();
        }
        await Shopify.MiniCartEvent.UpdateAsync();
        Hide_Loading();
      })
      .catch((error) => {
        alert('error');
        Hide_Loading();
        console.log(error);
      });
  };

  async function setAddInCartText() {
    //console.log(cart_info);

    if (cart_info == null) cart_info = await getCart();
    setTimeout(function () {
      $('.js-product-content .js-product-map').empty();
      if (cart_info != null && cart_info.items != null && cart_info.items.length > 0) {
        for (var i = 0; i < cart_info.items.length; i++) {
          var item = cart_info.items[i];
          var productId = item.product_id;
          var _obj = $(`.js-product-map-${productId}`);
          if (_obj.length > 0) {
            var qty = item.quantity;
            _obj.html(`(${qty} added to cart)`);
          }
        }
      }
    }, 1);
  };

  async function AddToCart(_obj) {
    Show_Loading(`Adding...`);
    var $this = $(_obj);
    var _qty = parseInt($this.siblings('.js-add-to-cart-quantity').val());
    var shopifyProperties = {};
    shopifyProperties._ideal_doorstyle = $this.attr('data-shortname');
    shopifyProperties._ideal_product_program = $this.attr('data-program');
    if( $this.attr('data-issampledoor') == 'true' ){
      shopifyProperties._ideal_is_sample_door = 'true';
    }else{
      shopifyProperties._ideal_is_sample_door = 'false';
    }
    shopifyProperties._ideal_production_value = $this.attr('data-productionvalue');

    var is_island_value = 'false'
    if( $this.attr('data-island') == 'true' ){
      is_island_value = 'true';
    }

    shopifyProperties._ideal_is_island = is_island_value;

    if (!await validAddToCart(is_island_value)) {
      if (is_island_value == 'false') {
        showIdealCartModal('Your cart contains Island products. Please remove them from your cart before adding this item.');
      } else {
        showIdealCartModal('Your cart contains non-Island products. Please remove them from your cart before adding this item.');
      }

      Hide_Loading();
      return;
    }




    var msg = 'Adding Qty ' + _qty + ' of ' + $this.attr('data-title') + '.';
    Show_Loading(msg);
    var cartItem = {
      id: $this.attr('data-variant'),
      quantity: _qty,
      properties: shopifyProperties,
    };
    var addCarts = await addItem(cartItem)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(async (response) => {
        //window.location.href='/cart';
        cart_info = await getCart();
        if (cart_info != null && cart_info.item_count > 0) {
          $('#minicartitemquantity').html(cart_info.item_count);
        } else {
          $('#minicartitemquantity').empty();
        }
        await setAddInCartText();
        await Shopify.MiniCartEvent.UpdateAsync();
        Hide_Loading();
      })
      .catch((error) => {
        alert('error');
        console.log(error);
        Hide_Loading();
      });
  };
  
  async function validAddToCart(is_island_value) {
        var cart = await getCart();
        await sleep(500);
        //console.log(cart);

        if ((cart.item_count || 0) == 0) return true;

        var currentIslandValue = String(is_island_value);

        var hasDifferentIslandItem = cart.items.some(function (item) {
          var itemIslandValue = item.properties && item.properties._ideal_is_island
            ? item.properties._ideal_is_island
            : 'false';

          return itemIslandValue != currentIslandValue;
        });

        return !hasDifferentIslandItem;
  };
 async function ClearCart() {
      const result = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
      });
      return result.json();
 }
function showIdealCartModal(message) {
  $('#idealCartModal').remove();

  var html = `
    <div class="modal fade" id="idealCartModal" tabindex="-1" role="dialog" style="position: fixed;top: 50%; left: 50%; margin: 0; transform: translate(-50%, -50%);">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Cart Conflict</h4>
          </div>

          <div class="modal-body">
            <p style="line-height:180%;">${message}</p>
          </div>

          <div class="modal-footer">
            <button type="button" id="idealClearCartBtn" class="btn btn-danger">
              Clear cart
            </button>
            <button type="button" class="btn btn-default" data-dismiss="modal" >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  var $modal = $(html);
  $('body').append($modal);

  $('#idealCartModal').off('hidden.bs.modal').on('hidden.bs.modal', function () {
    $modal.remove();
  });

  $('#idealClearCartBtn', $modal).on('click', async function () {
    sessionStorage.setItem('idealScrollTop', String(window.scrollY));
    Show_Loading('Clearing...');
    const cart = await ClearCart();
    $modal.remove();
    location.reload();
  });

  $modal.modal('show');
}

$(function () {
  var scrollTop = sessionStorage.getItem('idealScrollTop');

  if (scrollTop) {
    sessionStorage.removeItem('idealScrollTop');

    setTimeout(function () {
      window.scrollTo(0, Number(scrollTop));
    }, 100);
  }
});